import FinishedBoostModal from "./FinishedBoostModal";

export default FinishedBoostModal;



// WEBPACK FOOTER //
// ./src/shared/components/NavBar/BoostButton/FinishedBoostModal/index.js